export function isValidEmail(value) {
    let _value = value;
    if (Number.isInteger(_value)) {
        _value = _value.toString();
    }

    if (!_value || _value.length === 0) {
        return false;
    }

    let re = /\S+@\S+\.\S{2,}/;
    if (!re.test(_value)) {
        return false;
    }
    return true;
}
